import { useParams } from "react-router-dom";
import { UserGifList } from "components/feed/UserGifList";
import { MyGifList } from "components/feed/MyGifList";
import { CreatorInfo } from "components/profile/CreatorInfo";
import { useUserInfo } from "queries";
import { useSelector } from "react-redux";
import { IAppState } from "store/app-state";
import { Fragment, useEffect } from "react";
import { metrics } from "utils/metrics";
import { WithSideAds } from "components/ads";
import { ProfilePageSkyscraperEnum } from "components/ads/config/units/profilePageSkyscraper";
import { PageNotFound, REMOVED_USER, NOT_FOUND } from "components/page-not-found/PageNotFound";
import "pages/common.scss";
import "./style/UserPage.scss";
import { Loader } from "components/UI/Loader";
import { STATUS_GONE, STATUS_NOT_FOUND } from "services/BaseHttpService";

const validateUserId = (id: string | undefined): string => {
  if (id === undefined) {
    throw new Error("user id not specified");
  }

  return id;
};

export const UserPage = () => {
  const { id } = useParams();
  const { data, isError, isLoading, isSuccess, error } = useUserInfo(validateUserId(id));
  const currentUser = useSelector((state: IAppState) => state.user.currentUser);

  useEffect(() => {
    if (isSuccess && data) {
      metrics.sendProfileView({ userName: data.username });
    }
  }, [isSuccess, data]);

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    const status = error.response?.status;

    if (status === STATUS_GONE) {
      return <PageNotFound pageType={REMOVED_USER} />;
    }

    if (status === STATUS_NOT_FOUND) {
      return <PageNotFound pageType={NOT_FOUND} />;
    }
  }

  const isMyself = currentUser.username === data?.username;

  return (
    <Fragment>
      <WithSideAds
        leftAds={[
          ProfilePageSkyscraperEnum.ProfilePageSkyscraperL1,
        ]}
        rightAds={[
          ProfilePageSkyscraperEnum.ProfilePageSkyscraperR1,
        ]}
      >
        <div className="wide page creatorPage">
          <CreatorInfo myself={isMyself} user={data} context={null} />
          {data && !isMyself && <UserGifList id={data.username} />}
          {data && isMyself && <MyGifList id={data.username} />}
        </div>
      </WithSideAds>
    </Fragment>
  );
};

export default UserPage;
